/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core';
/* import specific icons */
import { faUserSecret, faSpinner, faInfoCircle, faMagnifyingGlass, faCaretLeft, faCaretRight, faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';

library.add(faUserSecret, faSpinner, faInfoCircle, faMagnifyingGlass, faCaretLeft, faCaretRight, faAngleLeft, faAngleRight);
